// extracted by mini-css-extract-plugin
module.exports = {"container":"_taYoFfNC","largeRadius":"_41cbkmsT","smallFont":"_YYS-C3km","large":"_8sPJt3q7"};